var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLogoEcontract(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 857 201",
    style: {
      enableBackground: "new 0 0 857 201"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000139990072898297294920000001224009882684737423_);}\n\t.st2{fill:url(#SVGID_00000129887230196910897720000001039746554413999249_);}\n\t.st3{fill:url(#SVGID_00000081636952921733522970000001472643488280086145_);}\n\t.st4{fill:url(#SVGID_00000031180165998217259710000001621101702503212701_);}\n\t.st5{fill:url(#SVGID_00000080192879062893968020000005147247634119841980_);}\n\t.st6{fill:url(#SVGID_00000068647356400177339540000011473179159384989061_);}\n\t.st7{fill:url(#SVGID_00000115476740053948066930000016495116289376318382_);}\n\t.st8{fill:url(#SVGID_00000009580112501164948660000002063457231451028144_);}\n\t.st9{fill:#D0D0D2;}\n\t.st10{fill:url(#SVGID_00000077296423318171367840000006741724555079121838_);}\n\t.st11{fill:#FF5A85;}\n\t.st12{fill:#ECEFF0;}\n\t.st13{fill:url(#SVGID_00000177471753730171434400000013097297261485948801_);}\n\t.st14{fill:url(#SVGID_00000087384504770874476930000005048982503985005451_);}\n\t.st15{fill:url(#SVGID_00000021114051144519364310000016690136654633639050_);}\n\t.st16{fill:#EF2347;}\n\t.st17{fill:#183589;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.4875,
    y1: 141.3513,
    x2: 214.7834,
    y2: -1.8828,
    gradientTransform: "matrix(1 0 0 -1 0 202.3937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D11934"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.7,74.1v10.4h41.7c1.1,1.9,2.9,3.3,4.9,4.2c2,0.8,4.3,0.9,6.4,0.3c2.1-0.6,4-1.9,5.3-3.6 c1.3-1.8,2.1-3.9,2.1-6.1c0-2.2-0.7-4.3-2.1-6.1c-1.3-1.8-3.2-3-5.3-3.6c-2.1-0.6-4.4-0.5-6.4,0.3c-2,0.8-3.8,2.3-4.9,4.2H262.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032646571986495726120000009287942491706667674_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.3156,
    y1: 123.835,
    x2: 233.1426,
    y2: -33.0633,
    gradientTransform: "matrix(1 0 0 -1 0 202.3937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D11934"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032646571986495726120000009287942491706667674_)"
    },
    d: "M340.5,95.1c-1.7,0-3.4,0.4-4.9,1.3 c-1.5,0.9-2.8,2.1-3.7,3.6h-20.5l-1.5,2.6l-13.2,22.9h-34v10.4h40l1.5-2.6l13.2-22.9h14.5c0.9,1.5,2.2,2.7,3.7,3.6 c1.5,0.9,3.3,1.3,5,1.3c1.8,0,3.5-0.5,5-1.4c1.5-0.9,2.8-2.2,3.6-3.7c0.9-1.5,1.3-3.3,1.3-5c0-1.8-0.5-3.5-1.4-5 c-0.9-1.5-2.1-2.8-3.7-3.7C344,95.6,342.3,95.1,340.5,95.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091000273030020896640000001612455420819650224_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.8127,
    y1: 141.5322,
    x2: 208.7357,
    y2: -13.5984,
    gradientTransform: "matrix(1 0 0 -1 0 202.3937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D11934"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091000273030020896640000001612455420819650224_)"
    },
    d: "M274.8,100h-12.1v10.4h12.1 c1.1,1.9,2.9,3.3,4.9,4.2c2,0.8,4.3,0.9,6.4,0.3c2.1-0.6,4-1.9,5.3-3.6c1.3-1.8,2.1-3.9,2.1-6.1s-0.7-4.3-2.1-6.1 c-1.3-1.8-3.2-3-5.3-3.6c-2.1-0.6-4.4-0.5-6.4,0.3C277.7,96.6,275.9,98.1,274.8,100L274.8,100z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045619920552553346970000007479501957267673005_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.8141,
    y1: 109.3901,
    x2: 244.7232,
    y2: -36.0699,
    gradientTransform: "matrix(1 0 0 -1 0 202.3937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D11934"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045619920552553346970000007479501957267673005_)"
    },
    d: "M320,146.2c-1.7,0-3.4,0.4-4.9,1.3 c-1.5,0.9-2.8,2.1-3.7,3.6h-48.7v10.5h48.7c0.9,1.5,2.2,2.8,3.7,3.6c1.5,0.9,3.3,1.3,5,1.3s3.5-0.5,5-1.4c1.5-0.9,2.8-2.2,3.6-3.7 c0.9-1.5,1.3-3.3,1.3-5c0-1.8-0.5-3.5-1.4-5c-0.9-1.5-2.2-2.8-3.7-3.7C323.5,146.6,321.7,146.2,320,146.2L320,146.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128479911185329542780000008006090767942640036_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.0983,
    y1: -69.0935,
    x2: 56.5209,
    y2: -2.5595,
    gradientTransform: "matrix(1 0 0 -1 0 202.3937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#C4C4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#ECEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBFCFC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128479911185329542780000008006090767942640036_)"
    },
    d: "M61.3,135.4l1.5,2.6h58.6v-10.4H68.8 l-13.2-22.9l-1.5-2.6H33.7c-1.1-1.9-2.9-3.3-4.9-4.2c-2-0.8-4.3-0.9-6.4-0.3c-2.1,0.6-4,1.9-5.3,3.6c-1.3,1.8-2,3.9-2,6.1 c0,2.2,0.7,4.3,2,6.1c1.3,1.8,3.2,3,5.3,3.6c2.1,0.6,4.4,0.5,6.4-0.3c2-0.8,3.8-2.3,4.9-4.2h14.5L61.3,135.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049197954767923603490000000057199308875173283_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.2871,
    y1: -71.9528,
    x2: 76.7098,
    y2: -5.4198,
    gradientTransform: "matrix(1 0 0 -1 0 202.3937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#C4C4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#ECEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBFCFC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049197954767923603490000000057199308875173283_)"
    },
    d: "M81.7,97.2c-1.8,0-3.5,0.5-5,1.3 c-1.5,0.9-2.8,2.1-3.7,3.7c-0.9,1.5-1.4,3.2-1.4,5c0,1.8,0.4,3.5,1.3,5c0.9,1.5,2.1,2.8,3.6,3.7c1.5,0.9,3.2,1.4,5,1.4 c1.8,0,3.5-0.4,5-1.3c1.5-0.9,2.8-2.1,3.7-3.6h19.4V102H90.2c-0.9-1.5-2.1-2.7-3.6-3.6S83.4,97.2,81.7,97.2L81.7,97.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176755209326740317100000001699218485039697065_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.8203,
    y1: -72.7423,
    x2: 82.243,
    y2: -6.2083,
    gradientTransform: "matrix(1 0 0 -1 0 202.3937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#C4C4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#ECEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBFCFC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176755209326740317100000001699218485039697065_)"
    },
    d: "M121.5,163.5v-10.5H54.2 c-1.1-1.9-2.9-3.3-4.9-4.2c-2-0.8-4.3-0.9-6.4-0.3c-2.1,0.6-4,1.9-5.3,3.6c-1.3,1.8-2,3.9-2,6.1s0.7,4.3,2,6.1 c1.3,1.8,3.2,3,5.3,3.6c2.1,0.6,4.4,0.5,6.4-0.3c2-0.8,3.8-2.3,4.9-4.2H109v25.8H139v-12.4h-17.5V163.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063626984946917958620000015561002757094151867_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.2672,
    y1: -70.252,
    x2: 64.6899,
    y2: -3.718,
    gradientTransform: "matrix(1 0 0 -1 0 202.3937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#C4C4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#ECEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBFCFC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063626984946917958620000015561002757094151867_)"
    },
    d: "M52.6,91.8c1.7,0,3.4-0.4,4.9-1.3 c1.5-0.9,2.8-2.1,3.7-3.6h60.3V76.5H61.2c-0.9-1.5-2.2-2.8-3.7-3.6c-1.5-0.9-3.3-1.3-5-1.3c-1.8,0-3.5,0.5-5,1.4s-2.8,2.2-3.6,3.7 c-0.9,1.5-1.3,3.3-1.3,5c0,1.8,0.5,3.5,1.4,5s2.2,2.8,3.7,3.7C49.1,91.4,50.8,91.8,52.6,91.8L52.6,91.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028308231969145447830000003861444483711121287_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.3761,
    y1: -84.0114,
    x2: 161.7991,
    y2: -17.4774,
    gradientTransform: "matrix(1 0 0 -1 0 202.3937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#C4C4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#ECEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBFCFC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028308231969145447830000003861444483711121287_)"
    },
    d: "M247.1,42.5l-25.3-25.4 c-1-1-2.4-1.6-3.9-1.6H111.3c-1.2,0-2.4,0.5-3.3,1.4c-0.9,0.9-1.4,2.1-1.4,3.3l0.2,175.6c0,1.5,0.6,2.9,1.6,3.9 c1,1,2.4,1.6,3.9,1.6h131c1.5,0,2.8-0.6,3.9-1.6c1-1,1.6-2.4,1.6-3.9V46.3c0-0.7-0.1-1.4-0.4-2.1C248,43.6,247.6,43,247.1,42.5 L247.1,42.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M61.3,131.4l1.5,2.6h58.6v-10.5H68.8l-13.2-22.9L54.1,98H33.7c-1.1-1.9-2.9-3.3-4.9-4.2 c-2-0.8-4.3-0.9-6.4-0.3c-2.1,0.6-4,1.9-5.3,3.6c-1.3,1.8-2,3.9-2,6.1c0,2.2,0.7,4.3,2,6.1c1.3,1.8,3.2,3,5.3,3.6 c2.1,0.6,4.4,0.5,6.4-0.3c2-0.8,3.8-2.3,4.9-4.2h14.5L61.3,131.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M81.7,93.2c-1.8,0-3.5,0.4-5,1.3c-1.5,0.9-2.8,2.1-3.7,3.7c-0.9,1.5-1.4,3.3-1.4,5c0,1.8,0.4,3.5,1.3,5 s2.1,2.8,3.6,3.7c1.5,0.9,3.2,1.4,5,1.4c1.8,0,3.5-0.4,5-1.3c1.5-0.9,2.8-2.1,3.7-3.6h19.4V98H90.2c-0.9-1.5-2.1-2.7-3.6-3.6 S83.4,93.2,81.7,93.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M121.5,159.5v-10.4H54.2c-1.1-1.9-2.9-3.3-4.9-4.2c-2-0.8-4.3-0.9-6.4-0.3c-2.1,0.6-4,1.9-5.3,3.6 c-1.3,1.8-2.1,3.9-2.1,6.1c0,2.2,0.7,4.3,2.1,6.1c1.3,1.8,3.2,3,5.3,3.6c2.1,0.6,4.4,0.5,6.4-0.3c2-0.8,3.8-2.3,4.9-4.2H109v25.8 H139v-12.4h-17.5V159.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M52.6,87.8c1.7,0,3.4-0.4,4.9-1.3c1.5-0.9,2.8-2.1,3.7-3.6h60.3V72.5H61.2c-0.9-1.5-2.2-2.8-3.7-3.6 s-3.3-1.3-5-1.3c-1.8,0-3.5,0.5-5,1.4c-1.5,0.9-2.8,2.2-3.6,3.7c-0.9,1.5-1.3,3.3-1.3,5c0,1.8,0.5,3.5,1.4,5 c0.9,1.5,2.2,2.8,3.7,3.7C49.1,87.4,50.8,87.8,52.6,87.8L52.6,87.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M247.1,38.5L221.8,13c-1-1-2.4-1.6-3.9-1.6H111.3c-1.2,0-2.4,0.5-3.3,1.4c-0.9,0.9-1.4,2.1-1.4,3.3l0.2,175.6 c0,1.5,0.6,2.9,1.6,3.9s2.4,1.6,3.9,1.6h131c1.5,0,2.8-0.6,3.9-1.6c1-1,1.6-2.4,1.6-3.9V42.3c0-0.7-0.1-1.4-0.4-2.1 C248,39.6,247.6,39,247.1,38.5L247.1,38.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070087932143554345490000013984335455703517086_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.561,
    y1: 108.5277,
    x2: 262.7096,
    y2: 108.5277,
    gradientTransform: "matrix(1 0 0 -1 0 202.3937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D11934"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070087932143554345490000013984335455703517086_)"
    },
    d: "M261.1,28L235.7,2.6 c-1-1-2.4-1.6-3.9-1.6H125.2c-1.2,0-2.4,0.5-3.3,1.4s-1.4,2.1-1.4,3.3l0.2,175.6c0,1.5,0.6,2.9,1.6,3.9c1,1,2.4,1.6,3.9,1.6h131 c1.5,0,2.8-0.6,3.9-1.6c1-1,1.6-2.4,1.6-3.9V31.9c0-0.7-0.1-1.4-0.4-2.1C262,29.1,261.6,28.5,261.1,28L261.1,28z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M261.1,28L235.7,2.6c-1-1-2.4-1.6-3.9-1.6H125.2c-1.2,0-2.4,0.5-3.3,1.4s-1.4,2.1-1.4,3.3v3.2 c0-1.2,0.5-2.4,1.4-3.3c0.9-0.9,2.1-1.4,3.3-1.4H230c1.5,0,2.8,0.6,3.9,1.6l25.4,25.4c1.4,1.7,2.6,3.7,3.5,5.7v-5.1 c0-0.7-0.1-1.4-0.4-2.1C262,29.1,261.6,28.5,261.1,28L261.1,28z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M243.4,108.9h-18.7l5.2-14.7c0.3-0.8,0.4-1.6,0.2-2.4c-0.2-0.8-0.6-1.5-1.1-2.1c-0.6-0.6-1.3-1-2.1-1.2 c-0.8-0.2-1.6-0.2-2.4,0.1l-24.4,7.6c0.5-4,0.7-8.1,0.7-12.2v-1.5c0-2.3-0.5-4.6-1.3-6.7c-0.9-2.1-2.2-4.1-3.8-5.7 c-1.6-1.6-3.6-2.9-5.7-3.8c-2.1-0.9-4.4-1.3-6.7-1.3s-4.6,0.5-6.7,1.3c-2.1,0.9-4.1,2.2-5.7,3.8c-1.6,1.6-2.9,3.6-3.8,5.7 c-0.9,2.1-1.3,4.4-1.3,6.7v7.3c0,0.6,0.1,1.2,0.3,1.7c0.2,0.6,0.5,1.1,0.9,1.5s0.9,0.8,1.5,1c0.5,0.2,1.1,0.4,1.7,0.4 s1.2-0.1,1.7-0.4c0.5-0.2,1-0.6,1.5-1s0.7-0.9,0.9-1.5c0.2-0.6,0.3-1.2,0.3-1.7v-7.5c0-2.3,0.9-4.6,2.6-6.2 c1.6-1.7,3.9-2.6,6.2-2.6c2.3,0,4.6,0.9,6.2,2.6c1.6,1.7,2.6,3.9,2.6,6.2v1.6c0,5-0.4,10-1.3,14.9l-19.8,6.2 c-3.3,1.1-6.1,3.1-8.1,5.9c-2,2.8-3.1,6.1-3.1,9.5v13.7c0,3.4,1.3,6.6,3.7,9s5.6,3.8,9,3.8c2.2,0,4.4-0.5,6.4-1.6 c1.9-1.1,3.5-2.7,4.7-4.6l3.1-4.8c5.4-9.1,9.3-19,11.7-29.3l0.2-0.9l20.3-6.3l-4.4,12.3c-0.2,0.7-0.3,1.4-0.2,2.1 c0.1,0.7,0.4,1.4,0.8,1.9c0.4,0.6,0.9,1,1.6,1.4c0.6,0.3,1.3,0.5,2,0.5h24.9c0.6,0,1.2-0.1,1.7-0.3c0.6-0.2,1.1-0.5,1.5-0.9 c0.4-0.4,0.8-0.9,1-1.5c0.2-0.5,0.4-1.1,0.4-1.7s-0.1-1.2-0.4-1.7s-0.6-1-1-1.5c-0.4-0.4-0.9-0.7-1.5-0.9 C244.6,108.9,244,108.8,243.4,108.9L243.4,108.9z M179,131.4l-2.9,4.8c-0.4,0.6-0.9,1.1-1.6,1.4c-0.6,0.3-1.3,0.5-2,0.5 c-1,0-2-0.5-2.8-1.2c-0.7-0.8-1.1-1.8-1.1-2.8v-13.7c0-1.6,0.5-3.1,1.5-4.4c0.9-1.3,2.2-2.2,3.7-2.8l14.8-4.4 C186.5,116.8,183.3,124.4,179,131.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050634811820983178110000004642136935042476192_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.514,
    y1: 71.7247,
    x2: 262.653,
    y2: 71.7247,
    gradientTransform: "matrix(1 0 0 -1 0 202.3937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#F9A7B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF2347"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050634811820983178110000004642136935042476192_)"
    },
    d: "M195.5,135.9c1.9-3.4,3.5-6.9,5.1-10.4 h62.9c1.4,0,2.7,0.6,3.7,1.5c1,1,1.5,2.3,1.5,3.7c0,1.4-0.6,2.7-1.5,3.7c-1,1-2.3,1.5-3.7,1.5H195.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134949678289329578210000011567218558068823229_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.3129,
    y1: 142.3127,
    x2: 253.2239,
    y2: 190.7959,
    gradientTransform: "matrix(1 0 0 -1 0 202.3937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#F9A7B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF2347"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134949678289329578210000011567218558068823229_)"
    },
    d: "M261.1,28L235.7,2.6c-1-1-2.4-1.6-3.9-1.6 H230v32.2c0,0.6,0.2,1.2,0.7,1.6c0.4,0.4,1,0.7,1.6,0.7h30.5v-3.6c0-0.7-0.1-1.4-0.4-2.1C262,29.1,261.6,28.5,261.1,28L261.1,28z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115480253883104136660000009625252851476740017_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.2789,
    y1: 149.916,
    x2: 249.7219,
    y2: 158.9647,
    gradientTransform: "matrix(1 0 0 -1 0 202.3937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AA1934"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115480253883104136660000009625252851476740017_)"
    },
    d: "M232.2,35.5c5.3,0,30.5,0,30.5,0V54 c0,0-2-8.1-8.8-12.7C248,37.2,242.4,36.6,232.2,35.5z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M384.7,21.2h15.6v70.9h-15.6V21.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M460.8,39.6c-1.5-1.9-3.4-3.3-5.7-4.3c-2.2-1-4.8-1.5-7.7-1.5c-2.9,0-5.7,0.6-8.2,1.7 c-2.5,1.1-4.6,2.7-6.5,4.8c-1.8,2-3.2,4.4-4.3,7.2c-1,2.8-1.5,5.8-1.5,9.1c0,3.3,0.5,6.4,1.5,9.2c1.1,2.7,2.5,5.1,4.3,7.2 c1.8,2,3.9,3.6,6.3,4.7c2.5,1.1,5.1,1.7,7.9,1.7c3.2,0,6-0.7,8.5-2c2.5-1.3,4.5-3.2,6.1-5.6l13,9.7c-3,4.2-6.8,7.3-11.4,9.3 c-4.6,2-9.3,3-14.2,3c-5.5,0-10.6-0.9-15.3-2.6c-4.7-1.7-8.7-4.2-12.1-7.4c-3.4-3.3-6.1-7.2-8-11.8c-1.9-4.6-2.8-9.7-2.8-15.4 c0-5.7,0.9-10.8,2.8-15.4c1.9-4.6,4.6-8.5,8-11.7c3.4-3.3,7.4-5.8,12.1-7.5c4.7-1.7,9.8-2.6,15.3-2.6c2,0,4.1,0.2,6.2,0.6 c2.2,0.3,4.3,0.9,6.4,1.7c2.1,0.8,4.2,1.9,6.1,3.2c1.9,1.3,3.7,3,5.2,4.9L460.8,39.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M479.2,56.7c0-5.7,0.9-10.8,2.8-15.4c1.9-4.6,4.6-8.5,8-11.7c3.4-3.3,7.4-5.8,12.1-7.5 c4.7-1.7,9.8-2.6,15.3-2.6c5.5,0,10.6,0.9,15.3,2.6c4.7,1.7,8.7,4.2,12.1,7.5c3.4,3.2,6,7.1,7.9,11.7c1.9,4.6,2.9,9.7,2.9,15.4 c0,5.7-1,10.8-2.9,15.4c-1.9,4.6-4.5,8.5-7.9,11.8c-3.4,3.2-7.4,5.7-12.1,7.4c-4.7,1.7-9.8,2.6-15.3,2.6c-5.5,0-10.6-0.9-15.3-2.6 c-4.7-1.7-8.7-4.2-12.1-7.4c-3.4-3.3-6.1-7.2-8-11.8C480.1,67.5,479.2,62.3,479.2,56.7z M495.4,56.7c0,3.3,0.5,6.4,1.5,9.2 c1.1,2.7,2.6,5.1,4.5,7.2c1.9,2,4.2,3.6,6.9,4.7c2.7,1.1,5.8,1.7,9.1,1.7s6.3-0.6,9-1.7c2.7-1.1,5.1-2.7,7-4.7 c1.9-2.1,3.4-4.5,4.4-7.2c1.1-2.8,1.6-5.9,1.6-9.2c0-3.3-0.5-6.3-1.6-9.1c-1-2.8-2.5-5.2-4.4-7.2c-1.9-2.1-4.3-3.7-7-4.8 c-2.7-1.1-5.7-1.7-9-1.7s-6.4,0.6-9.1,1.7c-2.7,1.1-5,2.7-6.9,4.8c-1.9,2-3.4,4.4-4.5,7.2C495.9,50.4,495.4,53.4,495.4,56.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M566.2,21.2h27.4c3.6,0,7,0.4,10.2,1.1c3.3,0.7,6.1,1.8,8.5,3.5c2.5,1.6,4.4,3.8,5.8,6.6 c1.5,2.7,2.2,6.2,2.2,10.3c0,5-1.3,9.3-3.9,12.8c-2.6,3.5-6.4,5.7-11.4,6.6l18,29.9h-18.7l-14.8-28.3h-7.7v28.3h-15.6V21.2z  M581.8,50.6h9.2c1.4,0,2.9,0,4.4-0.1c1.6-0.1,3-0.4,4.3-0.9c1.3-0.5,2.3-1.3,3.1-2.4c0.9-1.1,1.3-2.6,1.3-4.5 c0-1.8-0.4-3.2-1.1-4.3c-0.7-1.1-1.7-1.9-2.8-2.4c-1.1-0.6-2.4-1-3.9-1.2c-1.5-0.2-2.9-0.3-4.3-0.3h-10.2V50.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M631,21.2h26.3c3.7,0,7.1,0.3,10.4,1s6.1,1.8,8.5,3.5c2.5,1.6,4.4,3.8,5.8,6.6c1.5,2.7,2.2,6.2,2.2,10.4 c0,4.1-0.7,7.6-2,10.4c-1.3,2.8-3.2,5-5.5,6.7c-2.3,1.7-5.1,2.9-8.3,3.6c-3.2,0.7-6.7,1-10.4,1h-11.4v27.6H631V21.2z M646.6,51.3 H657c1.4,0,2.7-0.1,4-0.4c1.3-0.3,2.5-0.7,3.5-1.3c1.1-0.7,1.9-1.5,2.5-2.6c0.7-1.1,1-2.5,1-4.2c0-1.8-0.4-3.2-1.3-4.3 c-0.8-1.1-1.9-2-3.2-2.6c-1.3-0.6-2.7-1-4.3-1.1c-1.6-0.2-3.1-0.3-4.6-0.3h-8V51.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M429,179.9c-2.4,3.1-5.4,5.4-9.1,7.1c-3.7,1.7-7.5,2.5-11.4,2.5c-3.7,0-7.3-0.6-10.6-1.8 c-3.3-1.2-6.1-2.9-8.6-5.1c-2.4-2.3-4.3-5-5.7-8.1c-1.4-3.1-2.1-6.6-2.1-10.5s0.7-7.4,2.1-10.5c1.4-3.1,3.3-5.8,5.7-8 c2.5-2.3,5.3-4,8.6-5.2c3.3-1.2,6.9-1.8,10.6-1.8c3.5,0,6.6,0.6,9.4,1.8c2.9,1.2,5.3,2.9,7.2,5.2c2,2.2,3.5,4.9,4.6,8 c1.1,3.1,1.6,6.6,1.6,10.5v4.7h-34.8c0.6,2.9,1.9,5.2,3.9,6.9c2,1.7,4.5,2.5,7.4,2.5c2.5,0,4.5-0.5,6.2-1.6 c1.7-1.1,3.2-2.6,4.5-4.3L429,179.9z M416.3,158.5c0.1-2.5-0.8-4.7-2.5-6.5c-1.7-1.8-4-2.7-6.7-2.7c-1.7,0-3.1,0.3-4.4,0.8 c-1.3,0.5-2.4,1.2-3.3,2.1c-0.9,0.8-1.6,1.8-2.1,2.9c-0.5,1.1-0.7,2.2-0.8,3.4H416.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M488.7,135.9c-1.5-1.9-3.4-3.3-5.7-4.3c-2.2-1-4.8-1.5-7.7-1.5c-2.9,0-5.7,0.6-8.2,1.7 c-2.5,1.1-4.6,2.7-6.5,4.8c-1.8,2-3.2,4.4-4.3,7.2c-1,2.8-1.5,5.8-1.5,9.1c0,3.3,0.5,6.4,1.5,9.2c1.1,2.7,2.5,5.1,4.3,7.2 c1.8,2,3.9,3.6,6.3,4.7c2.5,1.1,5.1,1.7,7.9,1.7c3.2,0,6-0.7,8.5-2c2.5-1.3,4.5-3.2,6.1-5.6l13,9.7c-3,4.2-6.8,7.3-11.4,9.3 c-4.6,2-9.3,3-14.2,3c-5.5,0-10.6-0.9-15.3-2.6c-4.7-1.7-8.7-4.2-12.1-7.4c-3.4-3.3-6.1-7.2-8-11.8c-1.9-4.6-2.8-9.7-2.8-15.4 s0.9-10.8,2.8-15.4c1.9-4.6,4.6-8.5,8-11.7c3.4-3.3,7.4-5.8,12.1-7.5c4.7-1.7,9.8-2.6,15.3-2.6c2,0,4.1,0.2,6.2,0.6 c2.2,0.3,4.3,0.9,6.4,1.7c2.1,0.8,4.2,1.9,6.1,3.2c1.9,1.3,3.7,3,5.2,4.9L488.7,135.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M507.1,164c0-3.9,0.7-7.4,2.1-10.5c1.4-3.1,3.3-5.8,5.7-8c2.5-2.3,5.3-4,8.6-5.2c3.3-1.2,6.9-1.8,10.6-1.8 c3.7,0,7.2,0.6,10.5,1.8c3.3,1.2,6.2,2.9,8.6,5.2c2.5,2.2,4.4,4.9,5.8,8s2.1,6.6,2.1,10.5s-0.7,7.4-2.1,10.5s-3.3,5.8-5.8,8.1 c-2.4,2.2-5.3,3.9-8.6,5.1c-3.3,1.2-6.8,1.8-10.5,1.8c-3.7,0-7.3-0.6-10.6-1.8c-3.3-1.2-6.1-2.9-8.6-5.1c-2.4-2.3-4.3-5-5.7-8.1 C507.8,171.4,507.1,167.9,507.1,164z M522.1,164c0,3.7,1,6.6,3.1,8.9c2.1,2.3,5.1,3.4,8.9,3.4c3.8,0,6.7-1.1,8.8-3.4 c2.1-2.3,3.2-5.2,3.2-8.9c0-3.7-1.1-6.6-3.2-8.9c-2.1-2.3-5-3.4-8.8-3.4c-3.8,0-6.8,1.1-8.9,3.4C523.1,157.4,522.1,160.3,522.1,164 z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M569.9,139.7h14.4v6.6h0.2c0.5-0.9,1.1-1.9,2-2.8c0.9-0.9,1.9-1.8,3.1-2.5c1.2-0.7,2.6-1.3,4.1-1.8 c1.5-0.5,3.2-0.7,5-0.7c3.8,0,6.9,0.6,9.2,1.8c2.3,1.1,4.1,2.7,5.4,4.8c1.3,2.1,2.2,4.5,2.7,7.3c0.5,2.8,0.7,5.8,0.7,9.1v26.8h-15 v-23.8c0-1.4-0.1-2.8-0.2-4.3c-0.1-1.5-0.4-2.9-0.9-4.2c-0.5-1.3-1.2-2.3-2.3-3.1c-1-0.8-2.5-1.2-4.4-1.2s-3.5,0.4-4.7,1.1 c-1.2,0.7-2.1,1.6-2.8,2.8c-0.6,1.1-1,2.4-1.2,3.9c-0.2,1.5-0.3,3-0.3,4.6v24.2h-15V139.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M660.5,151.7h-13.2v16.2c0,1.3,0.1,2.6,0.2,3.7c0.1,1.1,0.4,2,0.9,2.8c0.5,0.8,1.2,1.4,2.1,1.9 c1,0.4,2.3,0.6,3.9,0.6c0.8,0,1.8-0.1,3.1-0.2c1.3-0.2,2.3-0.6,3-1.2V188c-1.7,0.6-3.4,1-5.2,1.2c-1.8,0.2-3.6,0.3-5.3,0.3 c-2.5,0-4.9-0.3-7-0.8c-2.1-0.5-4-1.4-5.6-2.5c-1.6-1.2-2.9-2.7-3.8-4.6c-0.9-1.9-1.3-4.1-1.3-6.8v-23.1h-9.6v-12h9.6v-14.4h15 v14.4h13.2V151.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M668.1,139.7h15v7.8h0.2c1.6-3,3.5-5.2,5.7-6.7c2.2-1.5,5-2.3,8.3-2.3c0.9,0,1.7,0,2.6,0.1 c0.9,0.1,1.7,0.2,2.4,0.4v13.7c-1.1-0.3-2.1-0.6-3.2-0.7c-1-0.2-2.1-0.3-3.2-0.3c-2.9,0-5.1,0.4-6.8,1.2c-1.7,0.8-3,1.9-3.9,3.4 c-0.9,1.4-1.4,3.1-1.7,5.1c-0.3,2-0.4,4.2-0.4,6.6v20.3h-15V139.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M739.3,182.2h-0.2c-1.7,2.6-3.9,4.5-6.7,5.6c-2.7,1.1-5.6,1.7-8.7,1.7c-2.3,0-4.5-0.3-6.6-1 c-2.1-0.6-3.9-1.5-5.5-2.8c-1.6-1.3-2.9-2.8-3.8-4.7c-0.9-1.9-1.4-4-1.4-6.5c0-2.8,0.5-5.2,1.5-7.1c1.1-1.9,2.5-3.5,4.2-4.8 c1.8-1.3,3.8-2.2,6.1-2.9c2.3-0.7,4.6-1.3,7-1.6c2.5-0.3,4.9-0.5,7.3-0.6c2.5-0.1,4.7-0.1,6.8-0.1c0-2.7-1-4.8-2.9-6.3 c-1.9-1.6-4.1-2.4-6.7-2.4c-2.5,0-4.7,0.5-6.8,1.6c-2,1-3.8,2.4-5.4,4.2l-8-8.2c2.8-2.6,6.1-4.5,9.8-5.8c3.7-1.3,7.6-2,11.6-2 c4.4,0,8,0.6,10.8,1.7c2.9,1.1,5.1,2.7,6.8,4.8c1.7,2.1,2.9,4.8,3.6,7.9c0.7,3.1,1,6.6,1,10.7v24.7h-13.8V182.2z M735.6,167 c-1.1,0-2.6,0.1-4.3,0.2c-1.7,0.1-3.3,0.3-4.9,0.8c-1.5,0.5-2.9,1.2-4,2.1c-1.1,0.9-1.6,2.2-1.6,3.9c0,1.8,0.8,3.1,2.3,4 c1.5,0.9,3.1,1.3,4.8,1.3c1.5,0,2.9-0.2,4.2-0.6c1.4-0.4,2.6-1,3.7-1.7c1.1-0.7,1.9-1.7,2.5-2.8c0.7-1.1,1-2.5,1-4V167H735.6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M795.4,155.4c-0.7-1.1-1.8-1.9-3.1-2.6c-1.3-0.7-2.8-1.1-4.3-1.1c-3.8,0-6.8,1.1-8.9,3.4 c-2.1,2.3-3.1,5.2-3.1,8.9c0,3.7,1,6.6,3.1,8.9c2.1,2.3,5.1,3.4,8.9,3.4c1.7,0,3.1-0.4,4.3-1.1c1.2-0.7,2.2-1.6,3.1-2.6l9.9,10.4 c-2.3,2.4-5.1,4.1-8.3,5.1c-3.1,0.9-6.1,1.4-9,1.4c-3.7,0-7.3-0.6-10.6-1.8c-3.3-1.2-6.1-2.9-8.6-5.1c-2.4-2.3-4.3-5-5.7-8.1 c-1.4-3.1-2.1-6.6-2.1-10.5s0.7-7.4,2.1-10.5c1.4-3.1,3.3-5.8,5.7-8c2.5-2.3,5.3-4,8.6-5.2c3.3-1.2,6.9-1.8,10.6-1.8 c2.9,0,5.9,0.5,9,1.5c3.2,0.9,6,2.6,8.3,5L795.4,155.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M843.8,151.7h-13.2v16.2c0,1.3,0.1,2.6,0.2,3.7c0.1,1.1,0.4,2,0.9,2.8c0.5,0.8,1.2,1.4,2.1,1.9 c1,0.4,2.3,0.6,3.9,0.6c0.8,0,1.8-0.1,3.1-0.2c1.3-0.2,2.3-0.6,3-1.2V188c-1.7,0.6-3.4,1-5.2,1.2c-1.8,0.2-3.6,0.3-5.3,0.3 c-2.5,0-4.9-0.3-7-0.8s-4-1.4-5.6-2.5c-1.6-1.2-2.9-2.7-3.8-4.6c-0.9-1.9-1.3-4.1-1.3-6.8v-23.1H806v-12h9.6v-14.4h15v14.4h13.2 V151.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoEcontract);
export default __webpack_public_path__ + "static/media/ic_logo_econtract.b32b3266350bb10a154825f9e8ea30ff.svg";
export { ForwardRef as ReactComponent };